import React from 'react'
import { useSelector } from 'react-redux';
import { selectMoldFilterVisible, selectTileView } from './store/selectors'; // Import the selector
import MoldReceivingSearch from './mold-receiving-search';
import MoldReceivingFilter from './mold-receiving-filter';
import MoldReceivingTile from './mold-receiving-tile';
import MoldReceivingTable from './mold-receiving-table';

const MoldReceivingContent = props => {
    const isFilterVisible = useSelector(selectMoldFilterVisible); // Use the selector
    const showTileView = useSelector(selectTileView); // Use the selector
  return (
    <div className="card table-list-card">
    <div className="card-body">
      <div className="table-top">
        <MoldReceivingSearch />
      </div>
      {isFilterVisible && <MoldReceivingFilter />}

      {!showTileView ? <MoldReceivingTile /> : <MoldReceivingTable />}
    </div>
  </div>
);
};

export default MoldReceivingContent